import KPI from 'components/KPI/KPI';
import { useCallback, useMemo } from 'react';
import {
  isB2BPrinter,
  isDSVPrinter,
} from 'modules/user-has-permission/user-has-permission';
import { useApp } from 'context/AppProvider';
import Portal from 'components/Portal/Portal';
import getCarrierName from 'modules/get-carrier-name/get-carrier-name';
import { Button, Dimmer, Loader } from 'semantic-ui-react';
import { useGenerateManifest } from 'hooks/useGenerateManifest';
import { getMessageFromAxiosError } from 'modules/message-factory/message-factory';
import './pending-manifest-kpi.scss';
import { useAlert } from 'context/AlertProvider';

export default function PendingManifestKPI({
  unmanifestedShipments,
  fetchUnmanifestedShipments = () => {},
  onManifestDownloaded = () => {},
}) {
  const alert = useAlert();
  const { menuIsOpen } = useApp();
  const mustShow = useMemo(
    () => (isB2BPrinter() || isDSVPrinter()) && menuIsOpen,
    [menuIsOpen],
  );
  const { handleDownloadManifest, requestingManifestDownload } =
    useGenerateManifest();

  const downloadManifest = useCallback(
    async (agency_code) => {
      try {
        await handleDownloadManifest(agency_code, onManifestDownloaded);
        await fetchUnmanifestedShipments();
      } catch (error) {
        alert.current.error(getMessageFromAxiosError(error));
      }
    },
    [
      handleDownloadManifest,
      fetchUnmanifestedShipments,
      onManifestDownloaded,
      alert,
    ],
  );

  const renderPendingManifest = useCallback(
    (pendingManiest) => {
      return (
        <article
          className="pending-manifest-kpi"
          key={pendingManiest.agency_code}
        >
          <Dimmer active={requestingManifestDownload} inverted>
            <Loader>Descargando manifiesto y etiqueta de pallet</Loader>
          </Dimmer>
          <div className="pending-manifest-kpi__agency">
            {getCarrierName(pendingManiest.agency_code)}
          </div>
          <div className="pending-manifest-kpi__value">
            {pendingManiest.count}
          </div>
          <Button
            className="pending-manifest-kpi__button"
            basic
            size="tiny"
            onClick={async (event, data) => {
              await downloadManifest(pendingManiest.agency_code);
            }}
          >
            Generar Pallet
          </Button>
        </article>
      );
    },
    [requestingManifestDownload, downloadManifest],
  );

  return (
    <Portal.In target="menu-left-widgets">
      {mustShow && !!unmanifestedShipments?.length && (
        <KPI
          title="Bultos por manifestar"
          contents={unmanifestedShipments.map((item) =>
            renderPendingManifest(item),
          )}
        />
      )}
    </Portal.In>
  );
}
